import React, { useState } from 'react';
import Sidebar from '../commonAdmin/Sidebar';
import Header from '../commonAdmin/Header';
import Footer from '../commonAdmin/Footer';
import { Row, Col, Card } from 'react-bootstrap';
import DeliveryRequestTypeSelect from './DeliveryRequestTypeSelect';
import './addRoutes.scss';
import { validateLocation } from './validateLocation';
import LocationSection from './LocationSection';
import delivaApiService from '../../../common/services/apiService';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { showErrorToast } from '../../../common/helpers/Utils';

const AddRoute = (props) => {
  const userId = localStorage.getItem('id');
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(false);
  const [routeFormData, setRouteFormData] = useState({
    deliveryType: 'LOCAL',
    source: {
      locality: '',
      city: '',
      state: '',
      country: '',
      zipcode: '',
      latitude: '',
      longitude: '',
    },
    destination: {
      locality: '',
      city: '',
      state: '',
      country: '',
      zipcode: '',
      latitude: '',
      longitude: '',
    },
    userId: userId,
  });

  const [formErrors, setFormErrors] = useState({
    source: {},
    destination: {},
  });
  const [isSubmitbtnClick, setIsSubmitbtnClick] = useState(false);
  const updateLocationFields = (locationDetails, sectionName) => {
    setRouteFormData((prevData) => {
      const updatedData = {
        ...prevData,
        [sectionName]: {
          ...prevData[sectionName],
          locality: locationDetails.locality,
          city: locationDetails.city,
          state: locationDetails.state,
          country: locationDetails.country,
          zipcode: locationDetails.zipcode,
          latitude: locationDetails.latitude,
          longitude: locationDetails.longitude,
        },
      };

      if (isSubmitbtnClick) {
        validateForm(updatedData);
      }

      return updatedData;
    });
  };

  const updateOtherFieldValue = (fieldValue, fieldName, sectionName) => {
    setRouteFormData((prevData) => {
      const updatedData = {
        ...prevData,
        [sectionName]: {
          ...prevData[sectionName],
          [fieldName]: fieldValue,
        },
      };

      // After updating the form data, trigger validation
      if (isSubmitbtnClick) {
        validateForm(updatedData);
      }

      return updatedData;
    });
  };

  // Function to handle changes in form fields
  const handleChange = (e) => {
    const { name, value } = e.target;

    setRouteFormData((prevData) => {
      let updatedData = {
        ...prevData,
        [name]: value,
      };

      // If deliveryType changes, reset source and destination fields
      if (name === 'deliveryType') {
        updatedData = {
          ...updatedData,
          source: {
            locality: '',
            city: '',
            state: '',
            country: '',
            zipcode: '',
            latitude: '',
            longitude: '',
          },
          destination: {
            locality: '',
            city: '',
            state: '',
            country: '',
            zipcode: '',
            latitude: '',
            longitude: '',
          },
        };
      }

      return updatedData;
    });
  };

  // Function to validate form data after change
  const validateForm = (formData) => {
    const sourceErrors = validateLocation(
      formData.source,
      'source',
      formData.deliveryType,
      formData.destination
    );
    const destinationErrors = validateLocation(
      formData.destination,
      'destination',
      formData.deliveryType,
      formData.source
    );
    setFormErrors({
      source: sourceErrors,
      destination: destinationErrors,
    });
    return {
      source: sourceErrors,
      destination: destinationErrors,
    };
  };
  const handleSubmit = async () => {
    setIsSubmitbtnClick(true);
    const errors = validateForm(routeFormData);

    if (
      Object.keys(errors.source).length ||
      Object.keys(errors.destination).length
    ) {
      setFormErrors(errors);
      return;
    }

    delivaApiService('addRoute', routeFormData)
      .then((response) => {
        if (response?.data?.status === 400) {
          showErrorToast(response?.data?.message);
          setIsLoading(false);
        } else if (response?.data?.status === 200) {
          history.push('/route-list');
        } else {
          setIsLoading(false);
        }
      })
      .catch((error) => {
        console.error('Failed to add route:', error);
        setIsLoading(false);
      });
  };

  return (
    <div className="page__wrapper h-100">
      <Header {...props} />
      <div className="mainContainer CustomerTable">
        <Row noGutters className="h-100">
          <Sidebar {...props} />
          <Col md={9} lg={10} className="boxTyp3">
            <div className="container-fluid">
              <div className="content-wrapper">
                <h3 className="font-weight-normal mb-0 line-ht color-33 fs-24">
                  Add New Route
                </h3>
                <h5 className="font-weight-normal mb-0 line-ht color-head">
                  <span
                    className="pointer"
                    onClick={() => history.push('/route-list')}
                  >
                    List of Routes
                  </span>
                  <span className="icon-next mx-2 fs12"></span>
                  <span className="pointer">Add New Route</span>
                </h5>
                <Card className="custom-card mt-4 addRouteCard">
                  <Card.Body>
                    <Row>
                      <Col lg={6}>
                        <DeliveryRequestTypeSelect
                          label="Delivery Request Type"
                          name="deliveryType"
                          value={routeFormData.deliveryType}
                          onLocationChange={handleChange}
                        />
                      </Col>
                    </Row>

                    <Row>
                      <Col md={6}>
                        {/* Pass sourceLocation data */}
                        <LocationSection
                          selectLabel="Source"
                          formSection="source"
                          deliveryType={routeFormData.deliveryType}
                          locationData={routeFormData.source}
                          onLocationChange={updateLocationFields}
                          updateOtherFieldValue={updateOtherFieldValue}
                          formErrors={formErrors.source}
                        />
                      </Col>
                      <Col md={6}>
                        {/* Pass destinationLocation data */}
                        <LocationSection
                          selectLabel="Destination"
                          formSection="destination"
                          deliveryType={routeFormData.deliveryType}
                          locationData={routeFormData.destination}
                          onLocationChange={updateLocationFields}
                          updateOtherFieldValue={updateOtherFieldValue}
                          formErrors={formErrors.destination}
                        />
                      </Col>
                    </Row>

                    <div className="mt-5">
                      <button
                        className="btnDefault btnOutline mr-3"
                        onClick={() => {
                          history.push('/route-list');
                        }}
                        style={{ minWidth: '140px' }}
                      >
                        Cancel
                      </button>
                      <button
                        type="button"
                        className="btnDefault btnPrimary"
                        onClick={handleSubmit}
                        disabled={isLoading}
                        style={{ minWidth: '140px' }}
                      >
                        Add
                      </button>
                    </div>
                  </Card.Body>
                </Card>
              </div>
            </div>
            <Footer {...props} />
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default AddRoute;
